import {
  AutosuggestProps,
  HomeVideoSearchItem,
  LabelsSearchItem,
  StoresSearchItem,
  VendorsSearchItem
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { UseItemViewReturn } from "hooks/useListItemView"

import ActionsAndInfoSideBar from "./ActionsAndInfoSideBar"

type LinkedItemsSearchItem =
  | HomeVideoSearchItem
  | LabelsSearchItem
  | VendorsSearchItem
  | StoresSearchItem

interface LinkedItem {
  id: string
  name: string
}

interface Item {
  createdAt: string
  isPublished?: boolean
  linkedItem?: LinkedItem
  publishedAt?: string | null
  updatedAt: string
}

export interface Props {
  actionButtonLabel: UseItemViewReturn["actionButtonLabel"]
  actionButtonOnClick: UseItemViewReturn["actionButtonOnClick"]
  isActionButtonLoading?: UseItemViewReturn["isActionButtonLoading"]
  isAdd?: boolean
  isAdmin?: boolean
  isEditMode: UseItemViewReturn["isEditMode"]
  isEditor?: boolean
  isLinkedItemsSuggestionsLoading?: boolean
  item?: Item
  linkedItemLabel?: string
  linkedItemPath?: string
  linkedItems?: LinkedItemsSearchItem[]
  linkedItemsSearchInputId?: string
  linkedItemsSearchLabel?: string
  onGetLinkedItemsSuggestions?: AutosuggestProps["onGetSuggestions"]
  onModalConfirmOpen: UseItemViewReturn["onModalConfirmOpen"]

  onSelectLinkedItemId?: (id: string, name: string) => void
  outlinedButtonLabel: UseItemViewReturn["outlinedButtonLabel"]
  outlinedButtonOnClick: UseItemViewReturn["outlinedButtonOnClick"]
  selectedLinkedItemId?: string
}

export interface ComponentProps extends Props {}

export default ActionsAndInfoSideBar
